module.exports = __webpack_public_path__ + "static/img/IMG_20240324_131707.56ae4ca8.jpg";